module.exports = __webpack_public_path__ + "img/D.bd9fcb4.jpg";